///
/// Vue Filters
///

import currency from './currency'
import date from './date'
import enums from './enums'
import percentage from './percentage'
import markdown from './markdown'
import number from './number'
import timeRange from './timeRange'
import timeFormat from './timeFormat'
import pluralize from './pluralize'
import numberName from './numberName'
import cornellLink from './cornellLink'
import guidelineLink from './guidelineLink'
import optionValue from './optionValue'
import toYears from './toYears'
import separator from './separator'
import suffix from './suffix'
import truncate from './truncate'
import timeAgo from './timeAgo'
import statuteLink from './statuteLink'
import shorten from './shorten'

export const installFilters = (app) => {
	app.config.globalProperties.$filters  = {
		currency,
		date,
		markdown,
		number,
		percentage,
		enums,
		timeRange,
		pluralize,
		numberName,
		cornellLink,
		guidelineLink,
		optionValue,
		timeFormat,
		toYears,
		separator,
		suffix,
		truncate,
		timeAgo,
		statuteLink,
		shorten,
	}
}
